import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import {getStateByPath} from "../../../redux/selectors";

// components
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import { LIST,  NO_DATA_FOUND} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";
// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";

// services
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import RoutForm from "./_form";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ColorFormatter} from "../../../components/tables/colorFormatter";
import {routService} from "../../../jwt/_services/clasificator/routService";
import TableAdapter from "../../../components/TableAdapter/TableAdapter";
import RoutFilters from "./_filter";

const RoutList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        if(filter || !app?.id || !udn?.id)
            return

        props.setFilter(path, {
            fbDataBase : { id: app?.fbDataBase?.id},
            item: {
                udn: { id : udn?.id },
                code: null
            }
        })
    }, [app, udn]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, routService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(RoutForm, { path, data, closeOnEscape:false, closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(RoutForm, { path })
    }
    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: routService,
        remove : genericIndexedActions.delete,
    } );

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID'
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'code',
        text: 'Código'
    }, {
        dataField: 'colorHex',
        text: 'Color Hex',
        formatter: (cell) => <ColorFormatter color={cell}/>
    }, {
        dataField: 'status',
        text: 'Activo',
        formatter: (cell) => <ActiveFormatter active={cell}/>
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '15%'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <RoutFilters path={path} />

        <CardBody>
            <TableAdapter
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={{pageIndex, pageSize, totalSize}}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(RoutList)